const amartCheckout = require('../checkout/amart-checkout');
const formValidation = require('sfraScripts/components/formValidation');
const createErrorNotification = require('sfraScripts/components/errorNotification');
const { deviceUtil } = require('../utils/device');
const configurations = window.Configurations;

var topBodyLogin = 0;
var isScrollBodyLogin = false;

module.exports = {
    handleLoginLink: function () {
        const self = this;
        $(document).on('click', '.header-icon-links .js-login-modal', function (e) {
            e.preventDefault();

            const $loginModal = $('.login-modal');
            if ($loginModal.length) {
                self.methods.openModal($loginModal);
            }
        });
    },
    initLoginModal: function () {
        const $loginModal = $('.login-modal');
        this.methods.init($loginModal);
    },
    methods: {
        init: function ($component) {
            if ($component.length) {
                const self = this;
                $component.on('click', '.wrap-custom-input .toggle-password', function (e) {
                    var $this = $(this);

                    var $input = $this.siblings('input');
                    var type = $input.attr('type') === 'password' ? 'text' : 'password';
                    $input.attr('type', type);
                    $this.find('svg.eye-slash').toggleClass('d-none', type !== 'password');
                    $this.find('svg.eye').toggleClass('d-none', type === 'password');
                });

                $component.on('click', '.wrap-custom-input .custom-placeholder', function (e) {
                    var $this = $(this);
                    var $input = $this.siblings('input');
                    $input.focus();
                });

                $component.on('click', '.login-modal-close', function (e) {
                    e.preventDefault();
                    $('header.header').toggleClass('login-modal-pop', false);
                    $('.login-modal-mask').toggleClass('active', false);
                    $('body').removeClass('has-login-modal');
                    const breakpoint = window.matchMedia('(max-width:991px)');
                    if (breakpoint.matches && isScrollBodyLogin) {
                        $(document).scrollTop(topBodyLogin);
                        topBodyLogin = 0;
                        isScrollBodyLogin = false;
                    }
                    if (deviceUtil.isMobileLayout()) {
                        const $loginModalWrapper = $('.login-modal-wrapper');
                        if($loginModalWrapper.length) {
                            $loginModalWrapper.removeClass('open');
                        }
                    } else {
                        $component.toggleClass('d-none', true);
                    }
                });

                $component.on('submit', 'form.login-form-modal', function (e) {
                    e.preventDefault();
                    var $form = $(this);
                    $.spinner().start();
                    $.ajax({
                        url: $form.attr('action'),
                        type: 'POST',
                        data: $form.serialize(),
                        success: function (data) {
                            var $wishlistErrorMessage = $('.login-form-nav .error-message-logged-out-add-to-wishlist');
                            if (data && $wishlistErrorMessage.length) {
                                $wishlistErrorMessage.toggleClass('d-none', true);
                            }
                            if (!data.success) {
                                $.spinner().stop();
                                formValidation($form, data);
                                $form.trigger('login:error', data);
                            } else {
                                window.dataLayer.push({
                                    event: "interaction",
                                    component: "account",
                                    action: "Successful Login"
                                });
                                if (data.gtmData) {
                                    self.addWishlistGTMData(data.gtmData, data.index);
                                }
                                $form.trigger('login:success', data);
                                amartCheckout.copyShippingToBilling();
                                $.spinner().stop();
                                location.href = data.redirectUrl;
                            }
                        },
                        error: function (data) {
                            if (data.responseJSON.redirectUrl) {
                                window.location.href = data.responseJSON.redirectUrl;
                            } else {
                                $form.trigger('login:error', data);
                                $.spinner().stop();
                            }
                        }
                    });
                });

                $component.on('submit', 'form.register-form-modal', function (e) {
                    e.preventDefault();
                    var $form = $(this);
                    $.spinner().start();
                    $form.trigger('login:register', e);
                    var recaptchaEnabled = configurations.recaptchaEnabled;
                    var recaptchaSiteKey = configurations.recaptchaSiteKey;

                    function callAjax(token) {
                        var formData = $form.serialize();
                        if (token) {
                            formData += '&token=' + token;
                        }
                        $.ajax({
                            url: $form.attr('action'),
                            type: 'post',
                            dataType: 'json',
                            data: formData,
                            success: function (data) {
                                var $wishlistErrorMessage = $('.login-form-nav .error-message-logged-out-add-to-wishlist');
                                if (data && $wishlistErrorMessage.length) {
                                    $wishlistErrorMessage.toggleClass('d-none', true);
                                }
                                if (!data.validForm) {
                                    $.spinner().stop();
                                    formValidation($form, data);
                                    e.stopImmediatePropagation();
                                    e.preventDefault();
                                    e.stopPropagation();
                                } else {
                                    window.dataLayer.push({
                                        event: "interaction",
                                        component: "account",
                                        action: "Account Created"
                                    });

                                    location.href = data.redirectUrl;
                                }
                            },
                            error: function (err) {
                                if (err.responseJSON.redirectUrl) {
                                    window.location.href = err.responseJSON.redirectUrl;
                                } else {
                                    createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                                }
                                $.spinner().stop();
                            },
                        });
                    }

                    if (recaptchaEnabled) {
                        grecaptcha.ready(function () {
                            grecaptcha.execute(recaptchaSiteKey, {
                                action: 'register'
                            }).then(function (token) {
                                callAjax(token);
                            });
                        });
                    } else {
                        callAjax();
                    }
                });

                if (!$('#login').length) {
                    $('body').on('submit', '.reset-password-form', function (e) {
                        const $form = $(this);
                        e.preventDefault();
                        e.stopPropagation();
                        e.stopImmediatePropagation();
                        const emailPattern = /^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/;
                        const email = $('#reset-password-email').val();
                        if (!emailPattern.test(email)) {
                            $('#reset-password-email').addClass('is-invalid');
                            $('#reset-password-email').closest('.form-group').find('.invalid-feedback').text('Please enter a valid email address.');
                            return false;
                        }
                        const url = $form.attr('action');
                        $.spinner().start();
                        $('.veil').css('position', 'fixed');
                        var recaptchaEnabled = configurations.recaptchaEnabled;
                        var recaptchaSiteKey = configurations.recaptchaSiteKey;

                        var checkoutLoginPage = $('#checkoutLoginPage').val();

                        function callAjax(token) {
                            var formData = $form.serialize();
                            if (token) {
                                formData += '&token=' + token;
                            }
                            $.ajax({
                                url: url,
                                type: 'post',
                                dataType: 'json',
                                data: formData,
                                success: function(data) {
                                    $.spinner().stop();
                                    if (!data.success) {
                                        formValidation($form, data);
                                    } else {
                                        var html = $('#requestPasswordResetModal').html();
                                        $('.request-password-body')
                                            .empty()
                                            .append(`<p>${data.receivedMsgBody}</p>`);
                                        if ($('#loginTab').length) {
                                            $('#submitEmailButton').remove();
                                        } else {
                                            if (checkoutLoginPage && checkoutLoginPage === 'true') {
                                                $('.send-email-btn')
                                                    .empty()
                                                    .html(
                                                        `<a class="btn btn-primary btn-block" data-dismiss="modal">${data.buttonText}</a>`,
                                                    );
                                            } else {
                                                $('.send-email-btn')
                                                    .empty()
                                                    .html(
                                                        `<a href="${data.returnUrl}" class="btn btn-primary btn-block">${data.buttonText}</a>`,
                                                    );
                                            }
                                        }
                                        if (checkoutLoginPage && checkoutLoginPage === 'true') {
                                            $('#requestPasswordResetModalBackup').empty().html(html);
                                        }
                                    }
                                },
                                error: function() {
                                    $.spinner().stop();
                                },
                            });
                        }

                        if (recaptchaEnabled) {
                            grecaptcha.ready(function () { // eslint-disable-line
                                grecaptcha.execute(recaptchaSiteKey, {
                                    action: 'resetpassword'
                                }).then(function (token) { // eslint-disable-line
                                    callAjax(token);
                                });
                            });
                        } else {
                            callAjax();
                        }
                        return false;
                    });

                    $('#requestPasswordResetModal').on('show.bs.modal', function (event) {
                        isScrollBodyLogin = false;
                        $component.find('.login-modal-close').trigger('click');
                        $('.header').addClass('header-down');
                    });

                    $('#requestPasswordResetModal').on('hide.bs.modal', function () {
                        $('body').removeClass('disable-overflow modal-open').css('padding-right', '');
                        const breakpoint = window.matchMedia('(max-width: 991px)');
                    
                        if (breakpoint.matches) {
                            $(document).scrollTop(topBodyLogin);
                            topBodyLogin = 0;
                            isScrollBodyLogin = false;
                        }

                        $('.modal-backdrop').remove();
                        $('body').removeClass('modal-open').css('padding-right', '');
                    });

                    $('#requestPasswordResetModal').on('hidden.bs.modal',  function () {
                        if (!$(this).find("#submitEmailButton").length) {
                            location.reload();
                            $.spinner().start();
                        }
                    });
                }
            }
        },
        closeModalOnOutsideClick: function ($component) {
            $(document).on('click.closeModal', '.login-modal-mask', function (event) {
                $component.find('.login-modal-close').trigger('click');
                $(document).off('click.closeModal');
            });
        },
        openModal: function ($component) {
            if ($component.length) {
                const breakpoint = window.matchMedia('(max-width:991px)');
                if (breakpoint.matches && !topBodyLogin) {
                    topBodyLogin = $(document).scrollTop();
                }
                $component.toggleClass('d-none', false);
                $('.login-modal-mask').toggleClass('active', true);
                $('header.header').toggleClass('login-modal-pop', true);
                $('body').addClass('has-login-modal');
                if(breakpoint.matches && !isScrollBodyLogin) {
                    $('body').css('top', - (topBodyLogin));
                    isScrollBodyLogin = true;
                }
                this.closeSomeElements();
                this.closeModalOnOutsideClick($component);
            }
        },
        closeSomeElements: function () {
            // Close header menu
            $('.menu-group-bottom').find('.dropdown-menu-container.show').removeClass('show');
            $('.menu-group-bottom').find('.nav-link.showing').removeClass('showing');
            $('.suggestions-mini').hide();
            // Close add to cart modal
            var $addToCartModal = $('#addToCartMessage-modal');
            if ($addToCartModal.length) {
                $addToCartModal.find('[data-dismiss="modal"]').trigger('click');
            }
        },
        addWishlistGTMData(product, index) {
            const productId = product.id;
            const name = product.productName + ' - ' + product.shortDescription;
            const brand = product.brand;
            const variant = product.finish;
            const minorCategory = product.minorCategory ? product.minorCategory : '';
            const price = product.price.list ? product.price.list.value : product.price.sales.value;
            const currency = product.price.sales.currency;
            const discount = product.price.list ? product.price.list.value - product.price.sales.value : 0;
            var promotions = product.promotions;
            var PromotionList = [];
            if (promotions) {
                for (let i = 0; i < promotions.length; i++) {
                    var promo = promotions[i];
                    if (promo && promo.enabled) {
                        PromotionList.push({ id: promo.id, name: promo.name });
                    }
                }
            }
            var category = product.categories;
            const categoryData = {
                category1: category && category.length > 0 && category[0] ? category[0].name : "",
                category2: category && category.length > 0 && category[1] ? category[1].name : "",
                category3: category && category.length > 0 && category[2] ? category[2].name : "",
                category4: category && category.length > 0 && category[3] ? category[3].name : "",
                category5: category && category.length > 0 && category[4] ? category[4].name : "",
                list_id: category && category.length > 0 && category[category.length - 1] ? category[category.length - 1].id : "",
                list_name: category && category.length > 0 && category[category.length - 1] ? category[category.length - 1].name : "",
            }
            var data = {
                event: "add_to_wishlist",
                ecommerce: {
                    currency: currency,
                    value: product.price.sales ? product.price.sales.value : price,
                    items: [
                        {
                            item_id: productId,
                            item_name: name,
                            affiliation: "Amart Online",
                            coupon: PromotionList,
                            currency: currency,
                            discount: discount.toFixed(2),
                            index: index,
                            item_brand: brand,
                            item_category: categoryData.category1,
                            item_category2: categoryData.category2,
                            item_category3: categoryData.category3,
                            item_category4: categoryData.category4,
                            item_category5: categoryData.category5,
                            item_list_id: categoryData.list_id,
                            item_list_name: categoryData.list_name,
                            item_variant: minorCategory,
                            item_colour: variant ? "Finish - " + variant : '',
                            location_id: "ChIJIQBpAG2ahYAR_6128GcTUEo",
                            price: price,
                            quantity: 1
                        }
                    ]
                }
            };
            window.dataLayer.push(function () {
                this.set('ecommerce.items', undefined);
            });
            window.dataLayer.push(data);
        }
    }
}
